import { fetchWishlistCount } from './wishlist-count.js';

function toFormUrlEncoded(obj) {
    const params = new URLSearchParams();
    Object.entries(obj).forEach(([key, value]) => {
        params.append(key, value == null ? '' : String(value));
    });
    return params;
}

async function postForm(url, data) {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: toFormUrlEncoded(data),
        credentials: 'same-origin',
    });

    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
        return response.json();
    }
    return response.text();
}

function getShareKeyFromUrl(url) {
    // gets the last segment between slashes: .../ABC123/ -> ABC123
    const match = String(url).match(/\/([A-Za-z0-9]+)\/$/);
    return match ? match[1] : '';
}

function setButtonState(button, { loading, favorite, label }) {
    if (loading) button.classList.add('is-loading');
    else button.classList.remove('is-loading');

    if (favorite) button.classList.add('is-favorite');
    else button.classList.remove('is-favorite');

    if (typeof label === 'string') {
        const span = button.querySelector('span');
        if (span) span.textContent = label;
    }
}

async function handleWishlistClick(button) {
    const link = button.querySelector('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    const isFavorite = button.classList.contains('is-favorite');

    setButtonState(button, { loading: true });

    try {
        if (isFavorite) {
            await postForm(href, {
                'tinvwl-product_id': link.dataset.wishlistPid,
                'tinvwl-action': 'remove',
                'tinvwl-security': link.dataset.nonce,
                'tinvwl-paged': 1,
                'tinvwl-sharekey': link.dataset.shareKey,
            });

            // Terug naar “add”-link
            const baseUrl = window.location.href.split('?')[0];
            const productId = button.dataset.productId;
            link.setAttribute('href', `${baseUrl}?add_to_wishlist=${encodeURIComponent(productId || '')}`);

            setButtonState(button, {
                loading: false,
                favorite: false,
                label: 'Voeg toe aan favorieten',
            });

            fetchWishlistCount();
        } else {
            const data = await postForm(href, {
                tinv_wishlist_id: '',
                tinv_wishlist_name: '',
                product_type: link.dataset.productType,
                product_id: link.dataset.productId,
                product_variation: '0',
                product_action: 'addto',
            });

            // If the endpoint returns JSON with these fields, we can update the dataset
            if (data && typeof data === 'object') {
                if (data.wishlist_pid != null) link.dataset.wishlistPid = String(data.wishlist_pid);
                if (data.wishlist_nonce != null) link.dataset.nonce = String(data.wishlist_nonce);
                if (data.wishlist_url) link.dataset.shareKey = getShareKeyFromUrl(data.wishlist_url);
            }

            // After adding, you use (as in your current code) this endpoint as the href
            link.setAttribute('href', '/?wc-ajax=tinvwl');

            setButtonState(button, {
                loading: false,
                favorite: true,
                label: 'Verwijder uit favorieten',
            });

            fetchWishlistCount();
        }
    } catch (err) {
        setButtonState(button, { loading: false });
        console.error('Wishlist request failed:', err);
    }
}

export function initWishlistButtons() {
    document.addEventListener('click', (event) => {
        const button = event.target.closest('.js-add-to-wishlist');
        if (!button) return;

        event.preventDefault();
        handleWishlistClick(button);
    });
}

// Keep the header badge in sync with add/remove actions that go through
// the TI WooCommerce Wishlist plugin UI (plugin-rendered add buttons in
// product loops, and the remove/bulk-action buttons on /favorietenlijst).
//
// We combine two strategies for robustness:
//  1. Subscribe to the plugin's own jQuery custom events when jQuery is
//     available (fast path, fires right when the plugin finishes its
//     AJAX request).
//  2. Fall back to native click listeners on the known plugin buttons
//     and refetch the count a short moment later. This still works even
//     if jQuery instances differ or the plugin event never reaches us.
const PLUGIN_BUTTON_SELECTOR = [
    'button[name="tinvwl-remove"]',
    'button[name="tinvwl-action-product_all"]',
    'button[name="tinvwl-action-product_apply"]',
    'button[name="tinvwl-action-product_selected"]',
    'button[name="tinvwl-add-to-cart"]',
    '.tinvwl_add_to_wishlist_button',
].join(',');

function scheduleRefetch() {
    setTimeout(fetchWishlistCount, 600);
    setTimeout(fetchWishlistCount, 1800);
}

export function initPluginEventListeners() {
    const $ = window.jQuery;
    if ($) {
        $('body').on(
            'tinvwl_wishlist_added_status tinvwl_wishlist_ajax_response',
            () => { fetchWishlistCount(); }
        );
    }

    document.addEventListener('click', (event) => {
        const btn = event.target.closest(PLUGIN_BUTTON_SELECTOR);
        if (!btn) return;
        scheduleRefetch();
    }, true);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initWishlistButtons();
        initPluginEventListeners();
    });
} else {
    initWishlistButtons();
    initPluginEventListeners();
}